import axios from 'axios'
import SessionStorage from 'sessionstorage';
import _ from 'underscore'
import { APIHOST, MOMENT_API_DATE_FORMAT } from "@/settings";
import PrintJs from "print-js";
import moment from "moment";
import mappers from "@/helpers/mappers";
import { jsonDataToExcel } from "@/js/XLSX";

class InvoiceService {
    register(data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/RegisterInvoice`, data, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        })
    }

    getExecutorLastInfo() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ExecutorLastInvoiceInfo`, {
            headers: { 'Authorization': `Bearer ${oAuthAccess.access_token}` }
        });
    }

    getAllbox({ sortBy, sortDesc, skip, limit, search, startExpireOn, endExpireOn, branch, isExecutorApproved, isCustomerApproved, isDeclined, status, statuses }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/InvoiceAllbox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search,
                start: startExpireOn ? startExpireOn.format(MOMENT_API_DATE_FORMAT) : null,
                end: endExpireOn ? endExpireOn.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch ? branch : null,
                isExecutorApproved: typeof (isExecutorApproved) === 'boolean' ? isExecutorApproved : null,
                isCustomerApproved: typeof (isCustomerApproved) === 'boolean' ? isCustomerApproved : null,
                isDeclined: typeof (isDeclined) === 'boolean' ? isDeclined : null,
                status:typeof (status) === "number" ? status : null,
                statuses:statuses
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getInfo(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/InvoiceInfo/${id}`, {
            headers: { 'Authorization': `Bearer ${oAuthAccess.access_token}` }
        });
    }

    getSignProperties(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/SignInvoiceProperties/${id}`, {
            headers: { 'Authorization': `Bearer ${oAuthAccess.access_token}` }
        });
    }

    printPdf(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        const promise = axios.get(`${APIHOST}/api/InvoicePdf`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: { id: id }
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            PrintJs(url);
        });

        return promise;
    }

    downloadExcelSingle(id) {
        return new Promise((resolve, reject) => {
            this.getInfo(id)
                .then(response => {
                    const invoiceInfo = mappers.mapInvoiceInfo(response.data)

                    const column1 = 'Магазин'
                    const column2 = 'Номер'
                    const column3 = 'Дата'
                    const column4 = 'Сумма'
                    const column5 = 'Номер договора'
                    const column6 = 'Дата договора'
                    const column7 = 'Поставщик'
                    const column8 = 'Заказчик'
                    const column9 = 'Подписан поставщиком'
                    const column10 = 'Подписан заказчиком'
                    const column11 = 'Отклонён закачиком'

                    let excelData = []

                    let invoiceMetaRow = {}
                    invoiceMetaRow[column1] = invoiceInfo.shipment.deliveryAddress
                    invoiceMetaRow[column2] = invoiceInfo.number
                    invoiceMetaRow[column3] = invoiceInfo.date.format('DD.MM.YYYY');
                    invoiceMetaRow[column4] = invoiceInfo.total;
                    invoiceMetaRow[column5] = invoiceInfo.contractNumber;
                    invoiceMetaRow[column6] = invoiceInfo.contractDate.format('DD.MM.YYYY');
                    invoiceMetaRow[column7] = invoiceInfo.executorDetails.name
                    invoiceMetaRow[column8] = invoiceInfo.customerDetails.name
                    invoiceMetaRow[column9] = invoiceInfo.isExecutorApproved ? 'Да' : 'Нет'
                    invoiceMetaRow[column10] = invoiceInfo.isCustomerApproved ? 'Да' : 'Нет'
                    invoiceMetaRow[column11] = invoiceInfo.shipment.isDeclined ? 'Да' : 'Нет'
                    excelData.push(invoiceMetaRow)

                    // empty row
                    excelData.push({})

                    let itemsHeaderRow = {}
                    itemsHeaderRow[column1] = '№'
                    itemsHeaderRow[column2] = 'Товар'
                    itemsHeaderRow[column3] = 'Ед.изм'
                    itemsHeaderRow[column4] = 'Количество'
                    itemsHeaderRow[column5] = 'Цена за единицу'
                    itemsHeaderRow[column6] = 'Стоимость'
                    itemsHeaderRow[column7] = 'НДС ставка'
                    itemsHeaderRow[column8] = 'НДС сумма'
                    itemsHeaderRow[column9] = 'Сумма с НДС'
                    itemsHeaderRow[column10] = ''
                    itemsHeaderRow[column11] = ''
                    excelData.push(itemsHeaderRow)


                    _.each(invoiceInfo.items, (item, index) => {
                        let itemRow = {}

                        itemRow[column1] = ` ${index + 1}`
                        itemRow[column2] = item.product
                        itemRow[column3] = item.measurement
                        itemRow[column4] = item.quantity
                        itemRow[column5] = item.price
                        itemRow[column6] = item.total
                        itemRow[column7] = item.ndsRate
                        itemRow[column8] = item.ndsValue
                        itemRow[column9] = item.totalWithNds
                        itemRow[column10] = ''
                        itemRow[column11] = ''

                        excelData.push(itemRow)
                    })

                    jsonDataToExcel(excelData, `Счёт-фактура ${invoiceInfo.number} от ${invoiceInfo.date.format('DD-MM-YYYY')} в ${invoiceInfo.shipment.deliveryAddress} на ${invoiceInfo.total} сум.xlsx`)

                    resolve()
                }, reject)
        })
    }

    downloadExcelAll(params, onEachInvoiceInfoComplete) {
        return new Promise((resolve, reject) => {

            this.getAllbox(params)
                .then(response => {
                    if (typeof (onEachInvoiceInfoComplete) === 'function')
                        onEachInvoiceInfoComplete();

                    const column0 = '№'
                    const column1 = 'Магазин'
                    const column2 = 'Номер'
                    const column3 = 'Дата'
                    const column4 = 'Сумма'
                    const column5 = 'Номер договора'
                    const column6 = 'Дата договора'
                    const column7 = 'Поставщик'
                    const column8 = 'Заказчик'
                    const column9 = 'Подписан поставщиком'
                    const column10 = 'Подписан заказчиком'
                    const column11 = 'Отклонён закачиком'

                    let excelData = []
                    _.each(response.data.Records, (invoiceRecord, index) => {
                        if (typeof (onEachInvoiceInfoComplete) === 'function')
                            onEachInvoiceInfoComplete();

                        const invoice = mappers.mapInvoice(invoiceRecord)

                        let invoiceMetaRow = {}
                        invoiceMetaRow[column0] = `${index + 1}`
                        invoiceMetaRow[column1] = invoice.shipment.deliveryAddress
                        invoiceMetaRow[column2] = invoice.number;
                        invoiceMetaRow[column3] = invoice.date.format('DD.MM.YYYY');
                        invoiceMetaRow[column4] = invoice.total;
                        invoiceMetaRow[column5] = invoice.contractNumber
                        invoiceMetaRow[column6] = invoice.contractDate.format('DD.MM.YYYY');
                        invoiceMetaRow[column7] = invoice.executorDetails.name
                        invoiceMetaRow[column8] = invoice.customerDetails.name
                        invoiceMetaRow[column9] = invoice.isExecutorApproved ? 'Да' : 'Нет'
                        invoiceMetaRow[column10] = invoice.isCustomerApproved ? 'Да' : 'Нет'
                        invoiceMetaRow[column11] = invoice.shipment.isDeclined ? 'Да' : 'Нет'
                        excelData.push(invoiceMetaRow)
                    })

                    jsonDataToExcel(excelData, `Реестр счёт-фактур.xlsx`)

                    resolve()
                }, reject)
        })
    }
    downloadExcelAllWithItems(params, onEachInvoiceInfoComplete) {
        this.getAllbox(params)
            .then(response => {
                const invoices = _.map(response.data.Records, invoiceViewModel => {
                    return mappers.mapInvoice(invoiceViewModel)
                })
                const loadInvoicePromices = []
                _.each(invoices, invoice => {
                    loadInvoicePromices.push(this.getInfo(invoice.id).finally(() => {
                        if (typeof (onEachInvoiceInfoComplete) === 'function')
                            onEachInvoiceInfoComplete();
                    }))
                })
                Promise.all(loadInvoicePromices).then(invoiceInfoPromiseResults => {
                    const column0 = '№'
                    const column1 = 'Магазин'
                    const column2 = 'Номер'
                    const column3 = 'Дата'
                    //
                    const column4 = 'Номер договора'
                    const column5 = 'Дата договора'
                    const column6 = 'Поставщик'
                    const column7 = 'Заказчик'
                    const column8 = 'Подписан поставщиком'
                    const column9 = 'Подписан заказчиком'
                    const column10 = 'Отклонён закачиком'
                    const column11 = "Товар"
                    const column12 = "Количество"
                    const column13 = "Ед.изм"
                    const column14 = "Цена за единицу без НДС"
                    const column15 = "Стоимость без НДС"
                    const column16 = "НДС ставка"
                    const column17 = "НДС сумма"
                    const column18 = 'Общая сумма'
                    let excelData = []
                    let index = 0
                    _.each(invoiceInfoPromiseResults, invoiceInfoPromiseResult => {
                        _.each(invoiceInfoPromiseResult.data.Items, invoiceItem => {
                            let invoiceMetaRow = {}
                            window.console.log(invoiceItem)
                            invoiceMetaRow[column0] = `${index + 1}`
                            invoiceMetaRow[column1] = invoiceInfoPromiseResult.data.Shipment.DeliveryAddress
                            invoiceMetaRow[column2] = invoiceInfoPromiseResult.data.Number;
                            invoiceMetaRow[column3] = moment(invoiceInfoPromiseResult.data.Date).format('DD.MM.YYYY');
                            invoiceMetaRow[column4] = invoiceInfoPromiseResult.data.ContractNumber;
                            invoiceMetaRow[column5] = moment(invoiceInfoPromiseResult.data.ContractDate).format('DD.MM.YYYY');
                            invoiceMetaRow[column6] = invoiceInfoPromiseResult.data.ExecutorDetail.Name
                            invoiceMetaRow[column7] = invoiceInfoPromiseResult.data.CustomerDetail.Name
                            invoiceMetaRow[column8] = invoiceInfoPromiseResult.data.IsExecutorApproved ? 'Да' : 'Нет'
                            invoiceMetaRow[column9] = invoiceInfoPromiseResult.data.IsCustomerApproved ? 'Да' : 'Нет'
                            invoiceMetaRow[column10] = invoiceInfoPromiseResult.data.Shipment.IsDeclined ? 'Да' : 'Нет'
                            invoiceMetaRow[column11] = invoiceItem.Product
                            invoiceMetaRow[column12] = invoiceItem.Quantity
                            invoiceMetaRow[column13] = invoiceItem.Measurement
                            invoiceMetaRow[column14] = invoiceItem.Price
                            invoiceMetaRow[column15] = invoiceItem.Total
                            invoiceMetaRow[column16] = invoiceItem.NdsRate
                            invoiceMetaRow[column17] = invoiceItem.NdsValue
                            invoiceMetaRow[column18] = invoiceItem.TotalWithNds
                            excelData.push(invoiceMetaRow)
                        })
                        index++
                    })
                    jsonDataToExcel(excelData, `Реестр счёт-фактур.xlsx`)
                }).catch(error => {
                    window.console.log(error)
                })
            })
    }
    delete(invoiceId,data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.put(`${APIHOST}/api/DeleteInvoice`, data,{
            params: {
                id: invoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    roamingInboxInvoiceDocumentsMeta({ limit, skip, contractor, invoiceNumber, invoiceDate }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/RoamingInboxInvoiceMeta`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    roamingIncomeSignedDocumentsMeta({ limit, skip, contractor, invoiceNumber, invoiceDate, signedDate, branch }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/KorzinkaRoamingIncomeSignedBox`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null,
                signedDate: signedDate ? signedDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    downloadRoamingIncomeSignedGreenList({ limit, skip, contractor, invoiceNumber, invoiceDate, signedDate, branch, serial }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        let promise = axios.get(`${APIHOST}/api/RoamingIncomeGreenList`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null,
                signedDate: signedDate ? signedDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch,
                serial: serial ? serial : null
            },
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `greenlist_${(new Date()).getTime()}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });

        return promise;
    }

    roamingOutgoSignedDocumentsMeta({ limit, skip, contractor, invoiceNumber, invoiceDate, signedDate, branch }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/KorzinkaRoamingOutgoSignedBox`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null,
                signedDate: signedDate ? signedDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    downloadRoamingOutgoSignedGreenList({ limit, skip, contractor, invoiceNumber, invoiceDate, signedDate, branch, serial }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        let promise = axios.get(`${APIHOST}/api/RoamingOutgoGreenList`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null,
                signedDate: signedDate ? signedDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch,
                serial: serial ? serial : null
            },
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `greenlist_${(new Date()).getTime()}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });

        return promise;
    }

    roamingIncomeMatchDocumentsMeta({ limit, skip, contractor, invoiceNumber, invoiceDate, branch }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/KorzinkaRoamingIncomeMatchBox`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    roamingIncomeHalfMatchDocumentsMeta({ limit, skip, contractor, invoiceNumber, invoiceDate, branch }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/KorzinkaRoamingIncomeHalfMatchBox`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    roamingOutgoMatchDocumentsMeta({ limit, skip, contractor, invoiceNumber, invoiceDate, branch }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/KorzinkaRoamingOutgoMatchBox`, {
            params: {
                skip: skip,
                limit: limit,
                contractor: typeof (contractor) === 'undefined' ? null : contractor,
                invoiceNumber: typeof (invoiceNumber) === 'undefined' ? null : invoiceNumber,
                invoiceDate: invoiceDate ? invoiceDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getItemCatalogs({ limit, search }) {
        return axios.get(`${APIHOST}/api/InvoiceItemCatalog`, {
            params: {
                limit: limit ? +limit : null,
                q: (typeof (search) === "undefined" || search === null) ? "" : search
            }
        })
    }
}

export default new InvoiceService();
